module.exports = __webpack_public_path__ + "img/about-ch2-urbanproblems-megacities.69be2e1d.svg";